// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"zq-z","imageAndVideoCount":"Aq-z","imageAndVideoContainer":"Bq-z","viewAllReviews":"Cq-z"};